import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../../actions/application';
import { APPLICATION_CONTEXTS } from '../../../constants';
import Slide from './Slide';

class SlideShow extends Component {
  /**************
   * Properties *
   **************/
  NEXT = 'next';
  PREVIOUS = 'previous';
  state = {
    currentIndex: 0
  };

  handleOnKeyUp = event => {
    switch (event.key) {
      case 'Enter':
      case 'n':
      case 'N':
        if (this.props.context === APPLICATION_CONTEXTS.SERVICES) {
          this.handleSelect();
        }
        break;
      case 'b':
      case 'B':
        if (this.props.context === APPLICATION_CONTEXTS.SERVICES) {
          this.handleSelect(this.PREVIOUS);
        }
        break;
      default:
    }
  };

  handleSelect = (direction = this.NEXT) => {
    if (this.state.currentIndex < this.props.slides.length) {
      if (direction === this.PREVIOUS) {
        this.handlePreviousSlide();
      } else {
        this.handleNextSlide();
      }
    } else {
      var route = this.props.endRoute != null ? this.props.endRoute : this.props.backRoute;
      this.props.history.push(route);
    }
  };

  handleNextSlide = () => {
    if (this.state.currentIndex < this.props.slides.length - 1) {
      this.setState({ currentIndex: this.state.currentIndex + 1 });
    } else if (this.props.wrap) {
      this.setState({ currentIndex: 0 });
    } else {
      var route = this.props.endRoute != null ? this.props.endRoute : this.props.backRoute;
      this.props.history.push(route);
    }
  };

  handlePreviousSlide = () => {
    if (this.state.currentIndex > 0) {
      this.setState({ currentIndex: this.state.currentIndex - 1 });
    } else {
      var route = this.props.backRoute != null ? this.props.backRoute : this.props.endRoute;
      this.props.history.push(route);
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    var that = this; //LLH??
    var slideNodes = this.props.slides.map(function(slide, index) {
      return <Slide key={index} image={slide} show={that.state.currentIndex === index} />;
    });
    return (
      <div className="slideshow">
        <div className="slider">{slideNodes}</div>
      </div>
    );
  }
}

const ConnectedSlideshow = connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(SlideShow);

export default withRouter(ConnectedSlideshow);
